import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['en', 'fr'] as const,
  defaultLocale: 'fr',
  pathnames: {
    '/': {
      en: '/',
      fr: '/',
    },
    '/login': {
      en: '/login',
      fr: '/connexion',
    },
    '/maintenance': {
      en: '/maintenance',
      fr: '/maintenance',
    },
    '/contact': {
      en: '/contact',
      fr: '/contact',
    },
    '/mail': {
      en: '/mail',
      fr: '/courriel',
    },
    '/gallery': {
      en: '/gallery',
      fr: '/galerie',
    },
    '/gallery/[id]': {
      en: '/gallery/[id]',
      fr: '/galerie/[id]',
    },
    '/news': {
      en: '/news',
      fr: '/actualites',
    },
    '/news/[id]': {
      en: '/news/[id]',
      fr: '/actualites/[id]',
    },
    '/legals': {
      en: '/legals',
      fr: '/mentions-legales',
    },
    '/legals/[slug]': {
      en: '/legals/[slug]',
      fr: '/mentions-legales/[slug]',
    },
    '/account': {
      en: '/account',
      fr: '/compte',
    },
    '/account/login': {
      en: '/account/login',
      fr: '/compte/connexion',
    },
    '/account/register': {
      en: '/account/register',
      fr: '/compte/inscription',
    },
    '/account/reset': {
      en: '/account/reset',
      fr: '/compte/reinitialiser',
    },
    '/account/home': {
      en: '/account/home',
      fr: '/compte/accueil',
    },
    '/account/circle': {
      en: '/account/circle',
      fr: '/compte/cercle',
    },
    '/account/payment': {
      en: '/account/payment',
      fr: '/compte/paiement',
    },
    '/account/payment/[status]': {
      en: '/account/payment/[status]',
      fr: '/compte/paiement/[status]',
    },
  },
});

export type Locale = (typeof routing)['locales'][number];
